import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  buildPlayStoreUrl,
  PLAY_STORE_URL,
  redirectToPlayStore,
} from '../../constants/appLinks';
import { logDownloadAndroidRedirect } from '../../services/downloadAndroidTracking';

/**
 * Meta ads land here → log UTM to MarketingAnalysis → hand off to Google Play
 * with Install Referrer so Android acquisition keeps the campaign.
 */
const DownloadAndroidPage: React.FC = () => {
  const { search } = useLocation();
  const playStoreUrl = buildPlayStoreUrl(search);

  useEffect(() => {
    let cancelled = false;

    void (async () => {
      await logDownloadAndroidRedirect(search);
      if (!cancelled) {
        redirectToPlayStore(search);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [search]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-[#1A2B4C] to-slate-900 flex items-center justify-center px-6">
      <div className="text-center max-w-md text-white">
        <div
          className="mx-auto mb-6 h-12 w-12 rounded-full border-2 border-[#C9A14B] border-t-transparent animate-spin"
          aria-hidden="true"
        />
        <p className="text-xl font-semibold mb-2">جاري التحويل إلى Google Play…</p>
        <p className="text-sm text-slate-300 mb-8">Redirecting to Morafaa on Google Play</p>
        <a
          href={playStoreUrl}
          className="inline-block rounded-lg bg-[#C9A14B] px-6 py-3 text-slate-900 font-semibold hover:bg-[#d4b35e] transition-colors"
        >
          حمّل التطبيق الآن
        </a>
        <p className="mt-4 text-xs text-slate-400">
          لو التحويل التلقائي ما اشتغلش، اضغط الزر فوق.
        </p>
        <noscript>
          <p className="mt-4">
            <a href={PLAY_STORE_URL}>Open Morafaa on Google Play</a>
          </p>
        </noscript>
      </div>
    </div>
  );
};

export default DownloadAndroidPage;
